const config = {
  placeholder: "Select value",
};

export default config;
